import Axios from 'axios'
import { Dispatch } from 'redux'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { ActionResponse } from 'util/types/index'
import { Partner, PartnerTypes } from './types'

export function createPartner (data: FormData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Partner>> => {
    createAlert({ code: 100, title: 'Cadastrando Parceiro', message: 'Aguarde...' })(dispatch)

    return Axios
      .post('/partner', data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerTypes.PARTNER_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar o parceiro')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function updatePartner (id: number|string, data: FormData, displayAlert = true) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Partner>> => {
    if (displayAlert) {
      createAlert({ code: 100, title: 'Atualizando Parceiro', message: 'Aguarde...' })(dispatch)
    }
    return Axios
      .put(`/partner/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerTypes.PARTNER_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o parceiro')
      })
      .then(async res => {
        if (displayAlert) {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deletePartner (id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Partner>> => {
    createAlert({ code: 100, title: 'Removendo Parceiro', message: 'Aguarde...' })(dispatch)
    return Axios
      .delete(`/partner/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerTypes.PARTNER_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o parceiro')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function getPartner (id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Partner>> => {
    return Axios
      .get(`/partner/${id}`)
      .then(res => res.data)
      .then(res => {
        dispatch({ type: PartnerTypes.PARTNER_GET, payload: res.data })
        return res
      })
  }
}

export function getPartnerList (params?: Record<string, string|number>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Partner[]>> => {
    return Axios
      .get('/partner', { params })
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: PartnerTypes.PARTNER_LIST, payload: res.data, pagination: res.pagination })
        }
        return res
      })
  }
}
